<template>
  <div name="custom-input">
    <input type="text" v-model="inputValue" />
  </div>
</template>

<script>
export default {
  name: 'custom-input',
  data () {
    return {
      inputValue: this.value
    }
  },
  watch: {
    inputValue () {
      this.$emit('input', this.inputValue)
    }
  },
  props: {
    value: {
      type: String
    }
  }
}
</script>


// WEBPACK FOOTER //
// customInput.vue?c03cf628